var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7333 12.3638C24.88 12.3638 25 12.4804 25 12.6228C25 18.1282 20.71 22.6595 15.2 23.2421V26.5402H20.1767C20.6333 26.5402 21 27.003 21 27.5759V28.7411C21 28.8835 20.9067 29 20.7933 29H7.20667C7.09333 29 7 28.8835 7 28.7411V27.5759C7 27.003 7.36667 26.5402 7.82333 26.5402H12.6667V23.2259C7.22 22.5883 3 18.0829 3 12.6228C3 12.4804 3.12 12.3638 3.26667 12.3638H5.26667C5.41333 12.3638 5.53333 12.4804 5.53333 12.6228C5.53333 17.1637 9.32333 20.8438 14 20.8438C18.6767 20.8438 22.4667 17.1637 22.4667 12.6228C22.4667 12.4804 22.5867 12.3638 22.7333 12.3638H24.7333Z",
    fill: "#FDF6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.125C17.13 18.125 19.6667 15.6911 19.6667 12.6875V5.4375C19.6667 2.43393 17.13 0 14 0C10.87 0 8.33333 2.43393 8.33333 5.4375V12.6875C8.33333 15.6911 10.87 18.125 14 18.125Z",
    fill: "#FDF6E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.0e60561a46517edb19a0656af534a128.svg";
export { ForwardRef as ReactComponent };